import React from 'react';
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {greyishBlue400} from "assets/jss/main";

import InputTextField from "components/input/new/InputTextField";
import SearchIcon from "components/icons/SearchIcon";

SearchBar.Proptypes = {
    onChange: PropTypes.func,
    customPlaceHolder: PropTypes.string,
    iconToTheRight: PropTypes.bool,
}

function SearchBar({onChange, customPlaceholder, iconToTheRight = false, style = {}, iconSize, ...props}) {
    return (
        <InputTextField
            placeholder={props.intl.formatMessage({id: customPlaceholder ?? 'list.search', defaultMessage:  customPlaceholder ?? 'list.search'})}
            onChange={(event) => onChange(event.target.value)}
            InputProps={{
                [iconToTheRight ? 'endAdornment' : 'startAdornment']: (
                    <SearchIcon style={iconToTheRight ? { marginRight: '16px' } : undefined} size={iconSize ? iconSize : 24} />
                )
            }}
            sx={{
                width: '100%',
                maxWidth: '100%',
                '& .MuiInputBase-root': {
                    input: {
                        padding: '12px 16px',
                        "&::placeholder": {
                            color: greyishBlue400,
                            opacity: 1
                        },
                    },
                },
                ...style
            }}
            {...props}
        />
    );
}

export default injectIntl(SearchBar);
